import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FileSelectEvent, FileUploadModule } from 'primeng/fileupload';
import { InputTextModule } from 'primeng/inputtext';
import { ReportTemplate } from '@src/api/reports';
import { BaseTableFormComponent, FormComponent, RowComponent, FieldComponent } from '@src/app/components';
import { fixNullToUndefined } from '@src/app/utils';
import { CaptionPipe } from '@src/app/pipes';

import { MAX_FILE_SIZE, TABLE_NAME } from '../../constants';
import { ReportTemplateUI } from '../../types';

import { FormDataType } from './types';
import { createForm } from './utils';

@Component({
  selector: 'create-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormComponent,
    RowComponent,
    FieldComponent,
    CaptionPipe,
    FileUploadModule,
    InputTextModule,
  ],
  templateUrl: './create-form.component.html',
  styleUrl: './create-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateFormComponent extends BaseTableFormComponent<FormDataType, ReportTemplateUI> {
  readonly tableName = TABLE_NAME;

  readonly maxFileSize = MAX_FILE_SIZE;

  constructor() {
    super(createForm());
  }

  override mapApiDataToFormData(data: ReportTemplate): FormDataType {
    const { name, description } = data;

    const formData: FormDataType = {
      name: name ?? null,
      description: description ?? null,
      file: null,
    };

    return formData;
  }

  override mapFormDataToApiData(data: FormDataType): ReportTemplateUI {
    const { name, description, file } = data;

    const apiData: ReportTemplateUI = {
      uuid: '', // TODO: удалить
      name: fixNullToUndefined(name),
      description: fixNullToUndefined(description),
      file: fixNullToUndefined(file),
    };
    return apiData;
  }

  onSelect(event: FileSelectEvent) {
    if (event.currentFiles.length) {
      this.form.controls.file.setValue(event.currentFiles[0]);
    }
  }
}
